import "./index.css";
import { Input, Button } from "antd";
import { DeleteOutlined, ArrowUpOutlined, ArrowDownOutlined } from "@ant-design/icons";
import { useState, useRef } from "react";

function Field(props) {
  const [isEditing, setIsEditing] = useState(false);
  const [label, setLabel] = useState(props.label);
  const inputRef = useRef(null);

  const onFinishUpdate = () => {
    setIsEditing(false);
    props.onUpdate(label);
  };

  const onUpdate = (event) => {
    setLabel(event.target.value);
  };

  const onStartUpdate = (event) => {
    event.preventDefault();
    setIsEditing(true);
    inputRef.current.focus({
      cursor: "all",
    });
  };

  return (
    <div className="Field">
      <div className="FieldTitle">
        <Input
          defaultValue={label}
          value={label}
          size="small"
          ref={inputRef}
          variant={isEditing ? "outlined" : "borderless"}
          onChange={onUpdate}
          onBlur={onFinishUpdate}
          onClick={onStartUpdate}
          onPressEnter={onFinishUpdate}
        />
      </div>
      <div className="">
        <Button type="text" danger icon={<DeleteOutlined />} onClick={props.onDelete}></Button>
      </div>
      <div className="">
        <Button type="text" icon={<ArrowUpOutlined />} onClick={props.onMoveUp}></Button>
      </div>
      <div className="">
        <Button type="text" icon={<ArrowDownOutlined />} onClick={props.onMoveDown}></Button>
      </div>
    </div>
  );
}

export default Field;
